'use strict';

declare var pdfMake: any;

module Patersons {

    export interface LedgerScope extends ng.IScope {
        accounts: Array<Account>;
        selectedAccount: Account;
        startDate: Date;
        endDate: Date;

        report: StandardLedgerReport;
        reportError: string;

        events: LedgerViewCtrl;

        summaryText: string;
        isError: boolean;
        hasData: boolean;
        isRendering: boolean;
        isDownloadReady: boolean;
    }

    //export class LedgerViewCtrl extends AbstractController {
    export class LedgerViewCtrl extends PortfolioBaseCtrl{
        scope: Patersons.LedgerScope;
        portfolioService: Patersons.PortfolioService;
        reportService: Patersons.ReportService;
        reportDownloadService: Patersons.ReportDownloadService;

        static $inject = ['$scope', '$log', '$location', '$window', '$state', '$stateParams', '$http', '$rootScope', 'reportService', 'reportDownloadService', 'portfolioService', 'navigationService'];

        constructor($scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, reportService, reportDownloadService, portfolioService, navigationService) {
            super($scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, navigationService);
            this.scope = $scope;
            this.scope.events = this;
            this.reportService = reportService;
            this.reportDownloadService = reportDownloadService;
            this.portfolioService = portfolioService;
            this.scope.isError = false;
            this.scope.hasData = false;

            this.load()

            this.scope.endDate = moment().toDate();
            this.scope.startDate = moment().subtract(30, 'days').toDate();
        }

        load() {
            this.scope.isRendering = true;
            this.portfolioService.getCombinedPortfolioData()
                .then((result) => {
                    this.scope.$apply(() => {
                        this.scope.accounts = result;
                        this.scope.isRendering = false;
                    });
                });
        }

        renderLedger = function (accountId: string, startDate: Date, endDate: Date) {
            this.scope.selectedAccount = this.scope.accounts.filter(a => a.accountId == accountId)[0];
            this.scope.startDate = startDate;
            this.scope.endDate = endDate;
            this.scope.generatedDate = new Date();

            this.scope.isRendering = true;
            this.scope.isDownloadReady = false;

            this.scope.isError = false;
            this.scope.hasData = false;

            this.reportService.getReport(ReportType.StandardLedger, this.scope.selectedAccount.accountId, this.scope.startDate, this.scope.endDate)
                .then((result) => {
                    this.scope.report = result;
                    this.scope.isDownloadReady = true;
                    this.scope.isError = false;
                    this.scope.hasData = true;
                },
                (reason) => {
                    //this.scope.reportError = reason.data.message;
                    this.scope.report = null;
                    this.scope.isDownloadReady = true;
                    this.scope.isError = true;
                    this.scope.hasData = false;
                })
                .finally(() => {
                    this.scope.isRendering = false;
                });
        };

        getSummaryText = function() {
            var text = "Report generated at " +
                moment.tz(this.scope.generatedDate, 'Australia/Sydney').format('h:mm a') +
                " AEST on " +
                moment.tz(this.scope.generatedDate, 'Australia/Sydney').format('D MMM YYYY') + ".";
            return text;
        }

        downloadPdf() {
            console.info('Download PDF');
            this.reportDownloadService.downloadPdfFile(this.scope.report, this.scope.selectedAccount);
        }

        downloadCsv() {
            console.info('Download CSV');
            this.reportDownloadService.downloadCsvFile(this.scope.report, this.scope.selectedAccount);
        }
    }
}
